module.exports = __webpack_public_path__ + "static/img/LOGO.df41815.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LOGO.png
// module id = kWZM
// module chunks = 1